import { RouterConfigModel } from '@b2c/services/common';
import { t } from '@b2c/services/decorator/display';
import { lazy } from 'react';
const orderAuth = false; // This should be set based on your authentication logic
const routes: RouterConfigModel[] = [
  // {
  //   path: '',
  //   index: true,
  //   component: lazy(() => import('./hotel/index/hotel-index')),
  //   title: t('Title_Nav_HotelIndex'),
  //   guardOption: {
  //     auth: false,
  //     secure: false,
  //     context: false,
  //   },
  //   data: {
  //     // showCovidAlert: true,
  //   },
  // },
  // {
  //   path: 'hotel/list',
  //   component: lazy(() => import('./hotel/list/hotel-list')),
  //   title: t('Title_Nav_HotelList'),
  //   guardOption: {
  //     auth: false,
  //     secure: true,
  //   },
  //   data: {
  //     // showCovidAlert: true,
  //   },
  // },
  {
    path: 'hotel/detail',
    component: lazy(() => import('./hotel/detail/hotel-detail')),
    title: t('Title_Nav_HotelDetails'),
    guardOption: {
      auth: false,
      secure: true,
    },
  },
  {
    path: 'order/fillin',
    component: lazy(() => import('./order/fillin/order-fillin')),
    title: t('Title_Nav_OrderFillin'),
    guardOption: {
      auth: orderAuth,
      secure: true,
    },
  },
  {
    path: 'order/pay',
    component: lazy(() => import('./order/pay/order-pay')),
    title: t('Title_Nav_OrderPay'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: orderAuth,
      secure: false,
    },
  },
  {
    path: 'order/result',
    component: lazy(() => import('./order/result/order-result')),
    title: t('Title_Nav_BookingResult'),
    guardOption: {
      auth: orderAuth,
      secure: false,
    },
  },
  {
    path: 'booking/detail',
    component: lazy(() => import('./booking/booking-detail')),
    title: t('Title_Nav_BookingDetails'),
    guardOption: {
      secure: false,
    },
  },
  {
    path: 'booking/list',
    component: lazy(() => import('./booking/booking-list')),
    title: t('Title_Nav_BookingList'),
    guardOption: {
      auth: true,
      secure: false,
    },
  },
  {
    path: 'user',
    component: lazy(() => import('./user/user-index')),
    title: t('Title_Nav_UserCenter'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: true,
      secure: false,
    },
  },
  {
    path: 'user/change-password',
    component: lazy(() => import('./user/change-password')),
    title: t('Title_Nav_ChangePassword'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: true,
      secure: false,
    },
  },
  {
    path: 'user/change-email',
    component: lazy(() => import('./user/change-email')),
    title: t('Title_Nav_ChangeEmail'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: true,
      secure: false,
    },
  },
  {
    path: 'account/login',
    component: lazy(() => import('./account/account-login')),
    title: t('Title_Nav_Login'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: false,
      secure: false,
    },
  },
  {
    path: 'account/register',
    component: lazy(() => import('./account/account-register')),
    title: t('Title_Nav_RegisterAccount'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: false,
      secure: false,
    },
  },
  {
    path: 'account/reset-password',
    component: lazy(() => import('./account/reset-password')),
    title: t('Title_Nav_ResetPassword'),
    data: {
      theme: 'white',
    },
    guardOption: {
      auth: false,
      secure: false,
    },
  },
  {
    path: 'faq',
    component: lazy(() => import('./faq/index/faq-index')),
    title: t('Title_FAQ'),
    data: {
      theme: 'white',
    },
  },
  {
    path: 'doc/:name',
    component: lazy(() => import('./doc/doc')),
  },
  {
    path: '*',
    component: lazy(() => import('./404')),
  },
];

export default routes;
